<template>
<el-tabs v-model="_taxonomy" @tab-click="handleClick">
    
    <el-tab-pane  v-for="(e,index) in taxonomies" :label="e" :name="index" :key="index">
        <span slot="label" class="label">{{e}}</span>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
    export default{
        props:['taxonomy'],
        computed:{
            _taxonomy:{
                set(v){ return v},
                get(v){ return this.taxonomy},
            }
            ,taxonomies(){
                return this.$store.state.taxonomy
            }
        },
        methods:{
            handleClick(v){
                this.$router.push('/own/manuscripts/create/'+v.name)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/manuscript/create/Tabs.vue